import PptxGenJS from 'pptxgenjs';
import PowerPointSlideProcessor from '@app/services/export/ppt/slides/PowerPointSlideProcessor';
import IHomeSlideData from '@app/types/data/slides/IHomeSlideData';
import { presentationDimensions } from '@app/services/export/ppt/variables/constants';
import { Map } from '@app/services/export/ppt/classes/Map';

export default class PowerPointHomeSlideProcessor extends PowerPointSlideProcessor<IHomeSlideData> {
	protected masterName: string = this.slideData.id;

	public async processSlideData(): Promise<void> {
		this.presentation.defineSlideMaster({
			title: this.masterName,
			objects: Map.createMapMasterObjectsForImage(
				this.slideData.image,
				presentationDimensions.w,
				presentationDimensions.h
			)
		});

		this.createOverviewSlide();
		this.createSlideWithMainLocations();
	}

	public createOverviewSlide(): void {
		const slide: PptxGenJS.Slide = this.presentation.addSlide({ masterName: this.masterName });

		const map = new Map(
			slide,
			{
				image: this.slideData.image,
				map: this.slideData.map,
				labels: this.slideData.mapLabels,
				showCover: true,
				ignoreImage: true
			},
			{ x: 0, y: 0, w: presentationDimensions.w, h: presentationDimensions.h }
		);

		map.create();
	}

	public createSlideWithMainLocations(): void {
		const slide: PptxGenJS.Slide = this.presentation.addSlide({ masterName: this.masterName });

		const map = new Map(
			slide,
			{
				image: this.slideData.image,
				map: this.slideData.map,
				labels: this.slideData.mapLabels.filter(label => label.isSelectable),
				showCover: true,
				ignoreImage: true
			},
			{ x: 0, y: 0, w: presentationDimensions.w, h: presentationDimensions.h }
		);

		map.create();
	}

	protected getSlideCount(): number {
		return 2;
	}
}
